import styled from 'styled-components'
import { ASSETS } from '../../../../../constants/assets'

export const BioCardHolder = styled.div<{ $hasMiniBio: boolean }>`
  display: flex;
  flex-direction: column;
  width: 282px;
  height: 436px;
  margin-bottom: 32px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 222px;
    height: 387px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 360px;
    height: 522px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 328px;
    height: 485px;
  }

  ${({ theme, $hasMiniBio }: any) =>
    $hasMiniBio
      ? `
    ${theme.breakpoints.up('sm')} {
      .BioCardWrapper {
        cursor: pointer;
        &:hover {
          .BioCardContent-FullName-Label {
            color: ${theme.webMktNewPalette.action.light.primary};
          }
          img {
            filter: brightness(85%);
          }
          .BioCardQuote-Block {
            background: ${theme.webMktNewPalette.background.dark.default};
            &::before {
              width: 16px;
              height: 16px;
              top: 12px;
              left: 12px;
              background-image: url(${ASSETS.ARROW_SMALL_RIGHT});
            }
          }
        }
      }
    }
    `
      : ``}
`

export const BioCardWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const BioCardImage = styled.div`
  position: relative;
  width: 282px;
  height: 324px;

  img {
    width: 100%;
    height: 100%;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 222px;
    height: 255px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 360px;
    height: 414px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 328px;
    height: 377px;
  }
`

export const BioCardQuote = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  top: 284px;
  left: 242px;
  background: ${({ theme }) => theme.webMktNewPalette.white};

  &::before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    top: 12px;
    left: 12px;
    background-image: url(${ASSETS.QUOTE});
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    top: 215px;
    left: 182px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    top: 374px;
    left: 320px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    top: 337px;
    left: 288px;
  }
`

export const BioCardContent = styled.div`
  &.BioCardContent-FullName {
    margin-top: 24px;
  }

  &.BioCardContent-Role {
    margin-top: 8px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    &.BioCardContent-Role {
      min-height: 48px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    &.BioCardContent-Role {
      min-height: unset;
    }
  }
`

export const BioCardFooter = styled.div`
  display: flex;
  margin-top: 4px;
  flex-direction: row;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-top: 1px;
  }
`

export const SocialMediaItem = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  &.BioPost__SocialMedia-Item svg {
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }

  &.BioCardFooter-TwitterProfile {
    top: 2px;
    left: 2px;
    margin-right: 16px;
    background-image: url(${ASSETS.TWITTER});
  }

  &.BioCardFooter-LinkedInProfile {
    margin-left: 2px;
    background-image: url(${ASSETS.LINKEDIN});
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    &:hover {
      &.BioCardFooter-TwitterProfile {
        background-image: url(${ASSETS.TWITTER_HOVER});
      }

      &.BioCardFooter-LinkedInProfile {
        background-image: url(${ASSETS.LINKEDIN_HOVER});
      }
    }
    &.BioPost__SocialMedia-Item svg:hover path {
      fill: ${({ theme }) => theme.webMktPalette.icon.blueLight};
    }
  }
`
